import { CoreBancarioImagesContainer } from './CoreBancarioImagesContainer';
export default CoreBancarioImagesContainer;
